import { useDispatch, useSelector } from 'react-redux';
import { useStateWithDeferredHandling } from '../../shared/hooks/stateWithDeferredHandling';
import { useEvent } from '../../../../hooks/useEvent';

export const useValueWithDeferredDispatch = ({
  selector,
  createAction,
  delay,
}) => {
  const value = useSelector(selector);
  const dispatch = useDispatch();

  const deferredDispatch = (value) => dispatch(createAction(value));

  return useStateWithDeferredHandling({
    value,
    handler: deferredDispatch,
    delay,
  });
};

export const useFilterDispatchers = ({ value, createAction, cb }) => {
  const dispatch = useDispatch();

  const onApply = useEvent(() => {
    dispatch(createAction(value));

    if (isFn(cb)) {
      cb();
    }
  });

  const onReset = useEvent(() => {
    dispatch(createAction(undefined));

    if (isFn(cb)) {
      cb();
    }
  });

  return { onApply, onReset };
};

function isFn(fn) {
  return typeof fn === 'function';
}
